const ERROR_EVENT = "errorEvent";
const PREVIOUS_URL = "previousUrl";
export { ERROR_EVENT, PREVIOUS_URL };
